import config from "./config.json";

const isLocalHost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1");

const api = {
  ...config,
  global: isLocalHost ? `${window.location.origin}/api` : config.global,
  mssqlglobal: isLocalHost
    ? `${window.location.origin}/portal-api`
    : config.mssqlglobal,
};

export default api;
